import { cn } from "@/lib/cn";
import { Logomark } from "./Logomark";

/** Small icon-on-tile treatment — DESIGN.md §2.2 "Small icon" variant. */
export function LogomarkTile({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex size-8 shrink-0 items-center justify-center rounded-sm bg-surface-2 text-primary",
        className,
      )}
    >
      <Logomark size="sm" className="text-primary" />
    </span>
  );
}
